module.exports = __webpack_public_path__ + "static/media/25.72d35e4a.mp3";